// src/pages/ServicesPage.js
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import {
  Clock,
  CalendarCheck,
  UserPlus,
  Users,
  ClipboardCheck,
} from 'lucide-react';

const servicesData = [
  {
    icon: <Clock size={32} className="text-primary mb-3" />,
    title: 'Temporary Coverage',
    description:
      'Need CRNA coverage next week? We deliver short-term talent for PTO, FMLA, seasonal surges, or last-minute cancellations.',
  },
  {
    icon: <CalendarCheck size={32} className="text-success mb-3" />,
    title: 'Long-Term Contracts',
    description:
      'For 3-, 6-, or 12-month assignments, we help you maintain reliable coverage without committing to a full-time hire.',
  },
  {
    icon: <UserPlus size={32} className="text-warning mb-3" />,
    title: 'Permanent Placement',
    description:
      'Looking to hire? We introduce vetted CRNAs ready for permanent roles. Flat-fee, no markups, no surprises.',
  },
  {
    icon: <Users size={32} className="text-danger mb-3" />,
    title: 'Pre-Screened Talent Pool',
    description:
      'We maintain a curated roster of CRNAs — searchable by location, availability, and experience — ready when you are.',
  },
  {
    icon: <ClipboardCheck size={32} className="text-info mb-3" />,
    title: 'Consultation & Planning',
    description:
      'We start with a consult to understand your case mix, staffing gaps, and ideal fit — then build a custom plan.',
  },
];

const ServicesPage = () => {
  return (
    <Container className="my-5">
      <h2 className="text-center mb-5" data-aos="fade-up">
        What We Do
      </h2>
      <Row className="g-4">
        {servicesData.map((service, index) => (
          <Col
            md={6}
            lg={4}
            key={index}
            className="d-flex align-items-stretch"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <Card className="shadow-sm border-0 w-100 h-100 rounded-4 p-4 text-center">
              <div className="d-flex justify-content-center">{service.icon}</div>
              <Card.Body>
                <Card.Title className="fw-semibold mb-3">{service.title}</Card.Title>
                <Card.Text className="text-muted" style={{ fontSize: '0.95rem' }}>
                  {service.description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ServicesPage;
